import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/pictos/GreenStickpin.png'
import _imports_1 from '../../../assets/pictos/RedStickpin.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-dfd68a68")

_pushScopeId("data-v-dfd68a68")
const _hoisted_1 = { class: "head" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "title-header" }, "Origin-Destination Travel Time Matrix", -1)
const _hoisted_3 = { class: "tab-container" }
const _hoisted_4 = {
  ref: "tabs",
  layout: "center",
  position: "above",
  scale: "m"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("calcite-tab-nav", { slot: "tab-nav" }, [
  /*#__PURE__*/_createVNode("calcite-tab-title", { active: "" }, "Route"),
  /*#__PURE__*/_createVNode("calcite-tab-title", null, "Routes"),
  /*#__PURE__*/_createVNode("calcite-tab-title", null, "Slots"),
  /*#__PURE__*/_createVNode("calcite-tab-title", null, "Files"),
  /*#__PURE__*/_createVNode("calcite-tab-title", null, "Advanced settings")
], -1)
const _hoisted_6 = { active: "" }
const _hoisted_7 = { class: "tab-route-container" }
const _hoisted_8 = { class: "list-container" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "stick"
}, null, -1)
const _hoisted_10 = {
  label: "Event location",
  ref: "fromIdSelect",
  width: "full"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "list-container" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "stick"
}, null, -1)
const _hoisted_14 = {
  label: "Event location",
  ref: "toIdSelect",
  width: "full"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  "icon-position": "end",
  "icon-type": "chevron",
  style: {"margin-top":"15px"}
}
const _hoisted_17 = { "item-title": "Steps" }
const _hoisted_18 = { class: "steps" }
const _hoisted_19 = {
  class: "via-in-list",
  slot: "actions-start"
}
const _hoisted_20 = { class: "via-lng" }
const _hoisted_21 = { class: "step-and-save" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "osl-client" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createVNode("b", null, "Assigned entities: ", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" - Osl: ")
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" - Client groups: ")
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 0,
  class: "travelTimeResult"
}
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-dfd68a68>Travel time (in hours minutes seconds)</div><div class=\"travelTimeLine travelTimeHeader\" data-v-dfd68a68><div class=\"col-25\" data-v-dfd68a68> Time slot </div><div class=\"col-20\" data-v-dfd68a68> Calculated </div><div class=\"col-34\" data-v-dfd68a68> Predefined </div></div>", 2)
const _hoisted_39 = {
  key: 0,
  class: "travelTimeLine line-data travel"
}
const _hoisted_40 = { class: "col-25" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 0,
  class: "col-20"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_44 = { class: "col-34 col-predefined" }
const _hoisted_45 = { class: "input-container" }
const _hoisted_46 = { class: "display-flex" }
const _hoisted_47 = /*#__PURE__*/_createVNode("calcite-icon", {
  icon: "x",
  scale: "s"
}, null, -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("calcite-icon", {
  icon: "check",
  scale: "s"
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("calcite-loader", {
  class: "isHidden",
  style: {"color":"#005fa2"},
  active: "",
  inline: "",
  scale: "s"
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("calcite-icon", {
  icon: "pencil",
  scale: "s"
}, null, -1)
const _hoisted_51 = { class: "col-12" }
const _hoisted_52 = {
  key: 1,
  class: "col-8"
}
const _hoisted_53 = { class: "btn-calc-container" }
const _hoisted_54 = { class: "left-btn" }
const _hoisted_55 = { class: "tab-calculate" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", null, "Calculate the best route between each location and for each time slot", -1)
const _hoisted_57 = { class: "btn-compute-container" }
const _hoisted_58 = {
  key: 0,
  class: "compute-status"
}
const _hoisted_59 = {
  key: 1,
  class: "compute-status"
}
const _hoisted_60 = {
  key: 2,
  class: "compute-status"
}
const _hoisted_61 = { class: "slots" }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "travelTimeLine travelTimeHeader" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-30" }, " Name "),
  /*#__PURE__*/_createVNode("div", { class: "col-30" }, " Days "),
  /*#__PURE__*/_createVNode("div", { class: "col-30" }, " Time slot ")
], -1)
const _hoisted_63 = { class: "travelTimeLine line-data" }
const _hoisted_64 = { class: "col-30" }
const _hoisted_65 = {
  key: 0,
  class: "col-30 col-days"
}
const _hoisted_66 = { class: "col-30" }
const _hoisted_67 = { class: "col-9" }
const _hoisted_68 = { class: "buttons" }
const _hoisted_69 = {
  ref: "btnAddSlot",
  "icon-end": "plus",
  class: "btnAddSlot"
}
const _hoisted_70 = { class: "import-tab" }
const _hoisted_71 = /*#__PURE__*/_createVNode("div", { class: "text-help" }, " 1. Export calculated routes as .csv file. ", -1)
const _hoisted_72 = { class: "btn-container" }
const _hoisted_73 = { class: "import-block" }
const _hoisted_74 = /*#__PURE__*/_createVNode("div", { class: "text-help" }, " 2. Update predefined travel time (using .csv file). ", -1)
const _hoisted_75 = { class: "select-dir-container" }
const _hoisted_76 = {
  class: "display-dir",
  ref: "displayDir"
}
const _hoisted_77 = { class: "btn-container" }
const _hoisted_78 = { class: "advanced-settings-tab" }
const _hoisted_79 = {
  "icon-position": "end",
  "icon-type": "chevron",
  style: {"margin-top":"15px"}
}
const _hoisted_80 = { "item-title": "Route settings" }
const _hoisted_81 = { class: "transport" }
const _hoisted_82 = /*#__PURE__*/_createVNode("span", null, "Mode ", -1)
const _hoisted_83 = { ref: "modeSelect" }
const _hoisted_84 = /*#__PURE__*/_createStaticVNode("<calcite-option value=\"car\" data-v-dfd68a68>Car</calcite-option><calcite-option value=\"taxi\" data-v-dfd68a68>Taxi</calcite-option><calcite-option value=\"bus\" data-v-dfd68a68>Bus</calcite-option><calcite-option value=\"truck\" data-v-dfd68a68>Truck</calcite-option><calcite-option value=\"bicycle\" data-v-dfd68a68>Bike</calcite-option><calcite-option value=\"pedestrian\" data-v-dfd68a68>Pedestrian</calcite-option>", 6)
const _hoisted_90 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_91 = { class: "Advanced options" }
const _hoisted_92 = { class: "left" }
const _hoisted_93 = { class: "options" }
const _hoisted_94 = /*#__PURE__*/_createVNode("span", { class: "col50" }, "Traffic ", -1)
const _hoisted_95 = {
  class: "col30",
  ref: "traffic",
  scale: "m",
  switched: "",
  style: {"margin-left":"10px"},
  name: "switchTraffic",
  title: "Enabled: Latest traffic information is used for computing the best route.\r\rDisabled: Computes the route with historical traffic pattern."
}
const _hoisted_96 = { class: "options" }
const _hoisted_97 = /*#__PURE__*/_createVNode("span", { class: "col50" }, "Traverse gates", -1)
const _hoisted_98 = {
  class: "col30",
  ref: "traverseGate",
  switched: "",
  scale: "m",
  style: {"margin-left":"10px"},
  title: "Enabled: Allows to traverse private gates.\r\rDisabled: Avoid them."
}
const _hoisted_99 = { class: "options" }
const _hoisted_100 = /*#__PURE__*/_createVNode("span", { class: "col50" }, "Infer travel time", -1)
const _hoisted_101 = {
  class: "col30",
  ref: "useTravelTimeService",
  scale: "m",
  style: {"margin-left":"10px"},
  title: "Enabled: Returns the travel time for the free, average, and pessemistics traffic conditions for the selected the departure (or arrival) day and time.\r\rThis option is not applicable if the routing version is disabled or if the precomputed route option is enabled.\r\rNote, this routing service returns the free and average travel times if the infer travel time service has not be set up for the event region."
}
const _hoisted_102 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_103 = /*#__PURE__*/_createVNode("div", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createVNode("span", null, "Overlays"),
  /*#__PURE__*/_createVNode("select", { id: "multiselectOverlayMatrix" })
], -1)
const _hoisted_104 = {
  "icon-position": "end",
  "icon-type": "chevron",
  style: {"margin-top":"15px"}
}
const _hoisted_105 = { "item-title": "Matrix configuration" }
const _hoisted_106 = { class: "buttons" }
const _hoisted_107 = {
  ref: "addSlotWindow",
  class: "slotModal",
  "aria-labelledby": "modal-title",
  color: "blue"
}
const _hoisted_108 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Add slot", -1)
const _hoisted_109 = {
  slot: "content",
  class: "content"
}
const _hoisted_110 = {
  type: "text",
  ref: "slotName",
  placeholder: "Please enter a slot name (mandatory)"
}
const _hoisted_111 = { class: "selectDays" }
const _hoisted_112 = { class: "inputHour" }
const _hoisted_113 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Start at:", -1)
const _hoisted_114 = {
  "number-button-type": "vertical",
  type: "number",
  min: "0",
  max: "24",
  ref: "startAt"
}
const _hoisted_115 = /*#__PURE__*/_createVNode("div", null, "Hour", -1)
const _hoisted_116 = { class: "inputHour" }
const _hoisted_117 = /*#__PURE__*/_createVNode("div", { class: "label" }, "to:", -1)
const _hoisted_118 = {
  "number-button-type": "vertical",
  type: "number",
  min: "0",
  max: "24",
  ref: "to"
}
const _hoisted_119 = /*#__PURE__*/_createVNode("div", null, "Hour", -1)
const _hoisted_120 = {
  slot: "primary",
  width: "full",
  ref: "saveSlot"
}
const _hoisted_121 = {
  ref: "confirmSlotDeletion",
  "aria-labelledby": "modal-title",
  color: "blue"
}
const _hoisted_122 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Remove slot ", -1)
const _hoisted_123 = {
  slot: "content",
  class: "content"
}
const _hoisted_124 = /*#__PURE__*/_createTextVNode(" Do you want to remove slot ")
const _hoisted_125 = { class: "slotName" }
const _hoisted_126 = /*#__PURE__*/_createTextVNode("? ")
const _hoisted_127 = {
  ref: "confirmDeleteAllSlots",
  "aria-labelledby": "modal-title",
  color: "blue",
  active: "false"
}
const _hoisted_128 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Remove all slots", -1)
const _hoisted_129 = /*#__PURE__*/_createVNode("div", {
  slot: "content",
  class: "content"
}, " Do you want to remove all slots ? ", -1)
const _hoisted_130 = {
  ref: "confirmDeleteAllRoutes",
  "aria-labelledby": "modal-title",
  color: "blue"
}
const _hoisted_131 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Remove calculated routes", -1)
const _hoisted_132 = /*#__PURE__*/_createVNode("div", {
  slot: "content",
  class: "content"
}, " Do you want to remove all calculated routes ? ", -1)
const _hoisted_133 = {
  ref: "confirmGenerateMatrix",
  "aria-labelledby": "modal-title",
  color: "blue"
}
const _hoisted_134 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Generate matrix definition", -1)
const _hoisted_135 = /*#__PURE__*/_createVNode("div", {
  slot: "content",
  class: "content"
}, [
  /*#__PURE__*/_createTextVNode(" This action will generate or update the table containing the list of origins and destinations from the locations and transportation points used to compute the matrix. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Do you want to perform the operation ? ")
], -1)
const _hoisted_136 = {
  ref: "errorAddSlot",
  "aria-labelledby": "modal-title",
  color: "blue"
}
const _hoisted_137 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Invalid input values", -1)
const _hoisted_138 = {
  slot: "content",
  class: "content"
}
const _hoisted_139 = {
  ref: "confirmDeleteARoute",
  "aria-labelledby": "modal-title",
  color: "blue"
}
const _hoisted_140 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Remove a route", -1)
const _hoisted_141 = /*#__PURE__*/_createVNode("div", {
  slot: "content",
  class: "content"
}, " Do you want to remove this calculated route ? ", -1)
const _hoisted_142 = {
  ref: "confirmComputeAllRoutes",
  "aria-labelledby": "modal-title",
  color: "blue"
}
const _hoisted_143 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Calculate all routes", -1)
const _hoisted_144 = /*#__PURE__*/_createVNode("div", {
  slot: "content",
  class: "content"
}, [
  /*#__PURE__*/_createTextVNode(" Do you want to compute all routes ? "),
  /*#__PURE__*/_createVNode("div", { class: "italic" }, "It could take a long time")
], -1)
const _hoisted_145 = {
  ref: "confirmResetMatrix",
  "aria-labelledby": "modal-title",
  color: "blue"
}
const _hoisted_146 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Reset computation status", -1)
const _hoisted_147 = /*#__PURE__*/_createVNode("div", {
  slot: "content",
  class: "content"
}, [
  /*#__PURE__*/_createVNode("span", null, "This action will reset the computation status information. Be sure, a matrix computation is not in process."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "Do you want to perform the operation ?")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_font = _resolveComponent("font")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("calcite-tabs", _hoisted_4, [
        _hoisted_5,
        _createVNode("calcite-tab", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("calcite-select", _hoisted_10, [
                _createVNode("calcite-option", {
                  disabled: "",
                  value: "-1",
                  selected: _ctx.fromIdSelected === null
                }, "Select an origin ", 8, ["selected"]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventTransportation, (eventLocation) => {
                  return (_openBlock(), _createBlock("calcite-option", {
                    value: eventLocation,
                    selected: _ctx.fromIdSelected === eventLocation
                  }, [
                    (eventLocation.attributes.ParentLocationID != undefined)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, "   "))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(eventLocation.attributes.Name), 1)
                  ], 8, ["value", "selected"]))
                }), 256))
              ], 512)
            ]),
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("calcite-select", _hoisted_14, [
                _createVNode("calcite-option", {
                  disabled: "",
                  selected: _ctx.toIdSelected === null,
                  value: "-1"
                }, "Select a destination ", 8, ["selected"]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventTransportation, (eventLocation) => {
                  return (_openBlock(), _createBlock("calcite-option", {
                    value: eventLocation,
                    selected: _ctx.toIdSelected === eventLocation
                  }, [
                    (eventLocation.attributes.ParentLocationID != undefined)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, "   "))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(eventLocation.attributes.Name), 1)
                  ], 8, ["value", "selected"]))
                }), 256))
              ], 512)
            ]),
            _createVNode("calcite-accordion", _hoisted_16, [
              _createVNode("calcite-accordion-item", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  (_ctx.selectedTravelDefinition && _ctx.viaPointsHtml.length > -1)
                    ? (_openBlock(), _createBlock("calcite-value-list", {
                        key: 0,
                        ref: ((el) => _ctx.addSelectionChange(el)),
                        "label-editing-enabled": ""
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viaPointsHtml, (via, index) => {
                          return (_openBlock(), _createBlock("calcite-value-list-item", { value: via }, [
                            _createVNode("div", _hoisted_19, [
                              _createVNode("div", {
                                class: "via-color",
                                style: 'background-color:' + via.color + ';'
                              }, _toDisplayString(index+1), 5),
                              _createVNode("div", null, "Lat: " + _toDisplayString(_ctx.getCoordRounded(via.lat)), 1),
                              _createVNode("div", _hoisted_20, "Lng: " + _toDisplayString(_ctx.getCoordRounded(via.lng)), 1)
                            ]),
                            _createVNode("calcite-action", {
                              slot: "actions-end",
                              onClick: $event => (_ctx.removeViaPoint(via)),
                              icon: "x"
                            }, null, 8, ["onClick"])
                          ], 8, ["value"]))
                        }), 256))
                      ], 512))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("calcite-button", {
                      onClick: _cache[1] || (_cache[1] = $event => (_ctx.startStopAddingStep())),
                      class: "btn-add-step",
                      color: "neutral",
                      "icon-flip-rtl": "both",
                      "icon-start": "plus",
                      round: "",
                      scale: "s",
                      "split-child": "primary",
                      disabled: !_ctx.listsAreValid
                    }, [
                      (_ctx.isAddingStepInfo)
                        ? (_openBlock(), _createBlock("span", _hoisted_22, "Stop drawing"))
                        : _createCommentVNode("", true),
                      (!_ctx.isAddingStepInfo)
                        ? (_openBlock(), _createBlock("span", _hoisted_23, "Add steps"))
                        : _createCommentVNode("", true)
                    ], 8, ["disabled"]),
                    _createVNode("calcite-button", {
                      ref: "deleteAllPin",
                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.deleteAllPoints())),
                      disabled: !_ctx.viaIsRemove,
                      class: "btn-delete-all-pin",
                      color: "blue",
                      scale: "s",
                      l: "",
                      "icon-end": "trash",
                      title: "Delete all steps"
                    }, null, 8, ["disabled"]),
                    _createVNode("calcite-button", {
                      onClick: _cache[3] || (_cache[3] = $event => (_ctx.saveViaEdits())),
                      disabled: !_ctx.viaIsDirty,
                      loading: _ctx.isSavingVia,
                      class: "btn-save-via",
                      color: "blue",
                      "icon-end": "save",
                      scale: "s",
                      l: ""
                    }, null, 8, ["disabled", "loading"])
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  (_ctx.Osl.length > 0 || _ctx.Osl.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _hoisted_27
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.Osl.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_28, [
                        _hoisted_29,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Osl, (eachOsl, index) => {
                          return (_openBlock(), _createBlock("span", null, [
                            (index < _ctx.Osl.length -1)
                              ? (_openBlock(), _createBlock("span", _hoisted_30, _toDisplayString(eachOsl.name) + ", ", 1))
                              : (index == _ctx.Osl.length -1)
                                ? (_openBlock(), _createBlock("span", _hoisted_31, _toDisplayString(eachOsl.name), 1))
                                : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.ClientGroups.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_32, [
                        _hoisted_33,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ClientGroups, (eachClientGroups, index) => {
                          return (_openBlock(), _createBlock("span", null, [
                            (index < _ctx.ClientGroups.length -1)
                              ? (_openBlock(), _createBlock("span", _hoisted_34, _toDisplayString(eachClientGroups.name) + ", ", 1))
                              : (index == _ctx.ClientGroups.length -1)
                                ? (_openBlock(), _createBlock("span", _hoisted_35, _toDisplayString(eachClientGroups.name), 1))
                                : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.selectedTravelsTimePerSlot.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_36, [
                  _hoisted_37,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedTravelsTimePerSlot, (selectedTravelTimePerSlot, index) => {
                    return (_openBlock(), _createBlock(_Fragment, null, [
                      (selectedTravelTimePerSlot.attributes.slotName)
                        ? (_openBlock(), _createBlock("div", _hoisted_39, [
                            _createVNode("div", _hoisted_40, [
                              (selectedTravelTimePerSlot.attributes.slotName)
                                ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(selectedTravelTimePerSlot.attributes.slotName), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (selectedTravelTimePerSlot.attributes.CalculatedTime)
                              ? (_openBlock(), _createBlock("div", _hoisted_42, [
                                  _createTextVNode(_toDisplayString(_ctx.secondsToReadable(selectedTravelTimePerSlot?.attributes?.CalculatedTime)) + " ", 1),
                                  _hoisted_43,
                                  _createTextVNode(" " + _toDisplayString(Math.round((selectedTravelTimePerSlot?.attributes?.CalculatedDistance /1000) *
                                    100) /
                                    100) + " km ", 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_44, [
                              _createVNode("div", _hoisted_45, [
                                _createVNode("div", _hoisted_46, [
                                  _createVNode("input", {
                                    ref: 'input' + index,
                                    class: "input-predefined",
                                    disabled: true,
                                    type: "text",
                                    value: _ctx.secondsToReadable(selectedTravelTimePerSlot?.attributes?.PredefinedTime),
                                    id: "name",
                                    name: "name",
                                    required: "",
                                    minlength: "4",
                                    maxlength: "8",
                                    size: "10",
                                    onInput: $event => (_ctx.updateTimeHint(index))
                                  }, null, 40, ["value", "onInput"]),
                                  _createVNode("span", {
                                    ref: 'input-unit' + index,
                                    class: "isHidden"
                                  }, null, 512)
                                ]),
                                _createVNode("div", {
                                  ref: 'input-underline' + index,
                                  class: "underline hideIt"
                                }, null, 512),
                                _createVNode("div", {
                                  ref: 'input-hint' + index,
                                  class: "time-hint isHidden"
                                }, null, 512)
                              ]),
                              _createVNode("button", {
                                ref: 'input-cancel' + index,
                                class: "btn-with-icon isHidden",
                                onClick: $event => (_ctx.cancelEditPredefinedTime(index, selectedTravelTimePerSlot))
                              }, [
                                _hoisted_47
                              ], 8, ["onClick"]),
                              _createVNode("button", {
                                ref: 'input-validate' + index,
                                class: "btn-with-icon isHidden",
                                onClick: $event => (_ctx.validateEditPredefinedTime(index, selectedTravelTimePerSlot))
                              }, [
                                _hoisted_48,
                                _hoisted_49
                              ], 8, ["onClick"]),
                              _createVNode("button", {
                                ref: 'input-edit' + index,
                                class: "btn-with-icon",
                                onClick: $event => (_ctx.editPredefinedTime(index, selectedTravelTimePerSlot))
                              }, [
                                _hoisted_50
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("div", _hoisted_51, [
                              _createVNode("calcite-button", {
                                class: "btn-delete",
                                onClick: $event => (_ctx.openDeleteRouteValidation(selectedTravelTimePerSlot)),
                                "icon-end": "trash",
                                scale: "s",
                                alignment: "start",
                                appearance: "solid"
                              }, null, 8, ["onClick"])
                            ]),
                            (selectedTravelTimePerSlot.graphic)
                              ? (_openBlock(), _createBlock("div", _hoisted_52, [
                                  _createVNode("calcite-checkbox", {
                                    value: selectedTravelTimePerSlot,
                                    checked: "",
                                    onClick: _cache[4] || (_cache[4] = (evt) => {_ctx.showHideGraphic(evt)}),
                                    scale: "s"
                                  }, null, 8, ["value"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_53, [
              _createVNode("div", _hoisted_54, [
                _createVNode("calcite-button", {
                  color: "blue",
                  onClick: _cache[5] || (_cache[5] = $event => (_ctx.clearSelection())),
                  scale: "s"
                }, "Clear "),
                _createVNode("calcite-button", {
                  class: "refresh-btn",
                  ref: "refreshBtn",
                  color: "blue",
                  "icon-end": "refresh",
                  onClick: _cache[6] || (_cache[6] = $event => (_ctx.runRefresh())),
                  scale: "s"
                }, null, 512)
              ]),
              _createVNode("calcite-button", {
                ref: "computeARouteBtn",
                class: "btnCalculateARoute",
                alignment: "start",
                appearance: "solid",
                scale: "s",
                disabled: _ctx.isSavingVia || !_ctx.listsAreValid || (_ctx.currentStatus && _ctx.currentStatus?.isComputingRoutes),
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.calculateARoute())),
                loading: _ctx.loaderCalculateARoute
              }, " Compute the route ", 8, ["disabled", "loading"])
            ])
          ])
        ]),
        _createVNode("calcite-tab", _hoisted_55, [
          _hoisted_56,
          _createVNode("div", _hoisted_57, [
            _createVNode("calcite-button", {
              ref: "btnCalculate",
              scale: "s",
              onClick: _cache[8] || (_cache[8] = $event => (_ctx.openRunCalculateRoute())),
              alignment: "start",
              appearance: "solid"
            }, "Compute routes", 512)
          ]),
          _createVNode("div", null, [
            (_ctx.currentStatus && _ctx.currentStatus?.isComputingRoutes)
              ? (_openBlock(), _createBlock("div", _hoisted_58, " Computed routes : " + _toDisplayString(_ctx.currentStatus.routesComputed) + " / " + _toDisplayString(_ctx.currentStatus.routesToComputePerSlot), 1))
              : _createCommentVNode("", true),
            (_ctx.currentStatus && !_ctx.currentStatus?.isComputingRoutes && _ctx.currentStatus.lastComputation != 'Failed to get the OD computation status from the GIS Core Service.')
              ? (_openBlock(), _createBlock("div", _hoisted_59, " Last computation status: " + _toDisplayString(_ctx.currentStatus.lastComputation), 1))
              : _createCommentVNode("", true),
            (_ctx.currentStatus && !_ctx.currentStatus?.isComputingRoutes && _ctx.currentStatus.lastComputation == 'Failed to get the OD computation status from the GIS Core Service.')
              ? (_openBlock(), _createBlock("div", _hoisted_60, [
                  _createVNode(_component_font, { color: "red" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.currentStatus.lastComputation), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("calcite-tab", _hoisted_61, [
          _hoisted_62,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slots, (slot) => {
            return (_openBlock(), _createBlock("div", _hoisted_63, [
              _createVNode("div", _hoisted_64, _toDisplayString(slot.attributes.Name), 1),
              (_ctx.slots.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_65, _toDisplayString(slot.attributes.Days.replaceAll(',', ', ')), 1))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_66, _toDisplayString(slot.attributes.FromTimeSlot) + " - " + _toDisplayString(slot.attributes.ToTimeSlot), 1),
              _createVNode("div", _hoisted_67, [
                _createVNode("calcite-button", {
                  onClick: $event => (_ctx.openDeleteSlot(slot)),
                  "icon-end": "trash",
                  scale: "s"
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 256)),
          _createVNode("div", _hoisted_68, [
            (_ctx.slots.length > 1)
              ? (_openBlock(), _createBlock("calcite-button", {
                  key: 0,
                  ref: "btnDeleteAllSlot",
                  "icon-end": "trash",
                  onClick: _cache[9] || (_cache[9] = $event => (_ctx.openDeleteSlotValidation())),
                  color: "red",
                  class: "btn-delete",
                  disabled: "false"
                }, "Delete All", 512))
              : _createCommentVNode("", true),
            _createVNode("calcite-button", _hoisted_69, "Add", 512)
          ])
        ]),
        _createVNode("calcite-tab", _hoisted_70, [
          _createVNode("div", null, [
            _hoisted_71,
            _createVNode("div", _hoisted_72, [
              _createVNode("calcite-button", {
                ref: "btnGenerateFile",
                onClick: _cache[10] || (_cache[10] = $event => (_ctx.generateTravelsFile()))
              }, "Export", 512)
            ])
          ]),
          _createVNode("div", _hoisted_73, [
            _hoisted_74,
            _createVNode("input", {
              ref: "inputSelectFile",
              type: "file",
              id: "files",
              name: "files",
              class: "isHidden",
              accept: ".csv",
              onChange: _cache[11] || (_cache[11] = $event => (_ctx.updateDisplayDir()))
            }, null, 544),
            _createVNode("div", _hoisted_75, [
              _createVNode("div", _hoisted_76, null, 512),
              _createVNode("calcite-button", {
                class: "btn-browse",
                onClick: _cache[12] || (_cache[12] = $event => (_ctx.openSelectFile()))
              }, "...")
            ]),
            _createVNode("div", _hoisted_77, [
              _createVNode("calcite-button", {
                disabled: !_ctx.isImportDisable,
                class: "btn-import",
                ref: "btnImport",
                onClick: _cache[13] || (_cache[13] = $event => (_ctx.importSelectedFile()))
              }, "Import ", 8, ["disabled"])
            ])
          ])
        ]),
        _createVNode("calcite-tab", _hoisted_78, [
          _createVNode("calcite-accordion", _hoisted_79, [
            _createVNode("calcite-accordion-item", _hoisted_80, [
              _createVNode("div", _hoisted_81, [
                _hoisted_82,
                _createVNode("calcite-select", _hoisted_83, [
                  _hoisted_84
                ], 512)
              ]),
              _hoisted_90,
              _createVNode("div", _hoisted_91, [
                _createVNode("div", _hoisted_92, [
                  _createVNode("div", _hoisted_93, [
                    _hoisted_94,
                    _createVNode("calcite-switch", _hoisted_95, null, 512)
                  ]),
                  _createVNode("div", _hoisted_96, [
                    _hoisted_97,
                    _createVNode("calcite-switch", _hoisted_98, null, 512)
                  ]),
                  _createVNode("div", _hoisted_99, [
                    _hoisted_100,
                    _createVNode("calcite-switch", _hoisted_101, null, 512)
                  ])
                ])
              ]),
              _hoisted_102,
              _hoisted_103
            ])
          ]),
          _createVNode("calcite-accordion", _hoisted_104, [
            _createVNode("calcite-accordion-item", _hoisted_105, [
              _createVNode("div", _hoisted_106, [
                _createVNode("calcite-button", {
                  class: "btnCalculateARoute",
                  appearance: "solid",
                  scale: "s",
                  onClick: _cache[14] || (_cache[14] = $event => (_ctx.openGenerateMatrixValidation())),
                  loading: _ctx.loaderGenerateMatrix
                }, " Generate matrix definition ", 8, ["loading"]),
                _createVNode("calcite-button", {
                  ref: "btnDeleteAll",
                  class: "btn-delete",
                  scale: "s",
                  onClick: _cache[15] || (_cache[15] = $event => (_ctx.openDeleteValidation())),
                  color: "red",
                  alignment: "start",
                  appearance: "solid"
                }, " Delete all calculated routes ", 512),
                _createVNode("calcite-button", {
                  ref: "btnResetValidation",
                  class: "btn-delete",
                  scale: "s",
                  onClick: _cache[16] || (_cache[16] = $event => (_ctx.openResetValidation())),
                  color: "red",
                  alignment: "start",
                  appearance: "solid"
                }, " Reset computation status ", 512)
              ])
            ])
          ])
        ])
      ], 512),
      _createVNode("calcite-modal", _hoisted_107, [
        _hoisted_108,
        _createVNode("div", _hoisted_109, [
          _createVNode("div", null, [
            _createVNode("calcite-input", _hoisted_110, null, 512)
          ]),
          _createVNode("div", _hoisted_111, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
              return (_openBlock(), _createBlock("div", null, [
                _createVNode("calcite-checkbox", { name: day }, null, 8, ["name"]),
                _createTextVNode(" " + _toDisplayString(day.charAt(0).toUpperCase() + day.slice(1)), 1)
              ]))
            }), 256))
          ]),
          _createVNode("div", _hoisted_112, [
            _hoisted_113,
            _createVNode("calcite-input", _hoisted_114, null, 512),
            _hoisted_115
          ]),
          _createVNode("div", _hoisted_116, [
            _hoisted_117,
            _createVNode("calcite-input", _hoisted_118, null, 512),
            _hoisted_119
          ])
        ]),
        _createVNode("calcite-button", {
          slot: "back",
          width: "full",
          appearance: "outline",
          ref: "cancelSlot",
          onClick: _cache[17] || (_cache[17] = $event => (_ctx.cancelAddSlot()))
        }, "Cancel", 512),
        _createVNode("calcite-button", _hoisted_120, "Save", 512)
      ], 512),
      _createVNode("calcite-modal", _hoisted_121, [
        _hoisted_122,
        _createVNode("div", _hoisted_123, [
          _hoisted_124,
          _createVNode("span", _hoisted_125, _toDisplayString(_ctx.slotToDelete?.attributes.Name), 1),
          _hoisted_126
        ]),
        _createVNode("calcite-button", {
          slot: "back",
          width: "full",
          appearance: "outline",
          onClick: _cache[18] || (_cache[18] = $event => (_ctx.cancelDeleteSlot()))
        }, "Cancel "),
        _createVNode("calcite-button", {
          color: "red",
          ref: "confirmSlotDeletionBtn",
          slot: "primary",
          width: "full",
          onClick: _cache[19] || (_cache[19] = $event => (_ctx.confirmDeleteSlot()))
        }, " Delete", 512)
      ], 512),
      _createVNode("calcite-modal", _hoisted_127, [
        _hoisted_128,
        _hoisted_129,
        _createVNode("calcite-button", {
          slot: "back",
          width: "full",
          appearance: "outline",
          onClick: _cache[20] || (_cache[20] = $event => (_ctx.cancelDeleteSlots()))
        }, "Cancel "),
        _createVNode("calcite-button", {
          slot: "primary",
          color: "red",
          width: "full",
          onClick: _cache[21] || (_cache[21] = $event => (_ctx.confirmDeleteAllSlots()))
        }, "Delete ")
      ], 512),
      _createVNode("calcite-modal", _hoisted_130, [
        _hoisted_131,
        _hoisted_132,
        _createVNode("calcite-button", {
          slot: "back",
          width: "full",
          appearance: "outline",
          onClick: _cache[22] || (_cache[22] = $event => (_ctx.cancelDeleteRoute()))
        }, "Cancel "),
        _createVNode("calcite-button", {
          slot: "primary",
          color: "red",
          width: "full",
          onClick: _cache[23] || (_cache[23] = $event => (_ctx.confirmDeleteRoutes()))
        }, "Delete ")
      ], 512),
      _createVNode("calcite-modal", _hoisted_133, [
        _hoisted_134,
        _hoisted_135,
        _createVNode("calcite-button", {
          slot: "back",
          width: "full",
          appearance: "outline",
          onClick: _cache[24] || (_cache[24] = $event => (_ctx.cancelGenerateMatrix()))
        }, " Cancel "),
        _createVNode("calcite-button", {
          slot: "primary",
          color: "blue",
          width: "full",
          onClick: _cache[25] || (_cache[25] = $event => (_ctx.GenerateMatrix(), _ctx.cancelGenerateMatrix()))
        }, "Generate ")
      ], 512),
      _createVNode("calcite-modal", _hoisted_136, [
        _hoisted_137,
        _createVNode("div", _hoisted_138, _toDisplayString(_ctx.validateForm), 1),
        _createVNode("calcite-button", {
          slot: "primary",
          width: "full",
          onClick: _cache[26] || (_cache[26] = $event => (_ctx.closeErrorAddSlot()))
        }, "OK")
      ], 512),
      _createVNode("calcite-modal", _hoisted_139, [
        _hoisted_140,
        _hoisted_141,
        _createVNode("calcite-button", {
          slot: "back",
          width: "full",
          appearance: "outline",
          onClick: _cache[27] || (_cache[27] = $event => (_ctx.cancelDeleteARoute()))
        }, "Cancel "),
        _createVNode("calcite-button", {
          slot: "primary",
          color: "red",
          ref: "confirmDeleteARouteBtn",
          width: "full",
          onClick: _cache[28] || (_cache[28] = $event => (_ctx.confirmDeleteARoute()))
        }, " Delete", 512)
      ], 512),
      _createVNode("calcite-modal", _hoisted_142, [
        _hoisted_143,
        _hoisted_144,
        _createVNode("calcite-button", {
          slot: "back",
          width: "full",
          appearance: "outline",
          onClick: _cache[29] || (_cache[29] = $event => (_ctx.cancelComputeAllRoute()))
        }, " Cancel "),
        _createVNode("calcite-button", {
          slot: "primary",
          ref: "confirmDeleteARouteBtn",
          width: "full",
          onClick: _cache[30] || (_cache[30] = $event => (_ctx.runCalcul()))
        }, " Compute all routes", 512)
      ], 512),
      _createVNode("calcite-modal", _hoisted_145, [
        _hoisted_146,
        _hoisted_147,
        _createVNode("calcite-button", {
          slot: "back",
          appearance: "outline",
          onClick: _cache[31] || (_cache[31] = $event => (_ctx.cancelResetValidation()))
        }, "Cancel"),
        _createVNode("calcite-button", {
          slot: "primary",
          color: "red",
          onClick: _cache[32] || (_cache[32] = $event => {_ctx.resetMatrix(); _ctx.cancelResetValidation()})
        }, "Reset")
      ], 512)
    ])
  ]))
})